<div class="fieldselector-dialog">
    <div class="popup-msg-content" ng-class="{alert:options.alert}">
        <h1>{{$ctrl.header|translate:language}}</h1>
        <p>
            {{$ctrl.message|translate:language}}
        </p>
        <p>
            <div>
                {{'reportFilter.selectDate'|translate:language}}
                <c-autoform-select class="property-dropdown" id="dateTypeId" options="dateTypes" selected-option="selectedDateType" validation="dateTypeValidation" editable="true"></c-autoform-select>
            </div>
        </p>
        <p>
            <div>
                {{'reportFilter.fromDate'|translate:language}}
                <c-date-time-picker visible="true"
                                    date-time-value="fromDate"
                                    locale=""
                                    show-date-picker="true"
                                    show-time-picker="false"
                                    justify="full"
                                    id="dateTimeField-fromDate"
                                    validation="fromValidation" />
            </div>
            <div>
                {{'reportFilter.toDate'|translate:language}}
                <c-date-time-picker visible="true"
                                    date-time-value="toDate"
                                    locale=""
                                    show-date-picker="true"
                                    show-time-picker="false"
                                    justify="full"
                                    id="dateTimeField-toDate"
                                    validation="toValidation" />
            </div>
            <div>
                {{'reportFilter.stages'|translate:language}}
                <c-checkbox-list editable="stages.editable"
                                 config="stages"
                                 validation="stages.validation" />
            </div>
        </p>
    </div>
    <div class="popup-button-content">
        <span><button id="cancel" class="popup-msg-button" ng-click="$ctrl.cancel()"><span>{{$ctrl.buttonCancel}}</span></button></span>
        <span><button class="popup-msg-button btn-primary" ng-click="$ctrl.ok()" ng-class="{alert:options.alert}"><span>{{$ctrl.buttonSave}}</span></button></span>
    </div>
</div>

